import React from 'react';
import clsx from 'clsx';

import { toDollars } from '@utils/money';
import { BaseComponentProps } from '@utils/types/baseComponents';

import styles from './styles.module.scss';

type Props = {
  label: string;
  amount: number;
  amountBeforeDiscount?: number;
} & BaseComponentProps;

PriceLine.defaultProps = {};

export function PriceLine(props: Props) {
  const { containerStyle, label, amount, amountBeforeDiscount } = props;

  if (!amount) {
    return (
      <div
        className={clsx(['skeleton-box', containerStyle])}
        style={{ width: '100%', height: '14px', borderRadius: '4px' }}
      />
    );
  }

  return (
    <div className={clsx([styles.subtotal, containerStyle])}>
      <p className={styles.title}>{label}</p>

      <strong className={styles.amount}>
        {!!amountBeforeDiscount && amountBeforeDiscount !== amount && (
          <span className={styles.previousAmount}>
            {toDollars(amountBeforeDiscount)}
          </span>
        )}

        {toDollars(amount, 2)}
      </strong>
    </div>
  );
}
